// extracted by mini-css-extract-plugin
export default {"topNews":"index_topNews_wPGsI","first_title":"index_first_title_9-5s7","second_title":"index_second_title_6bNUt"};